<template>
  <div class="container">
    <div v-if="!this.url">
      <Loading
        v-if="
          (this.loader || this.objetoRetorno.aguarde) &&
          !this.objetoRetorno.mensagem
        "
      ></Loading>
    </div>
    <div
      class="embed-responsive embed-responsive-1by1"
      v-if="this.url"
      style="height: 100%; min-height: 700px;"
    >
      <iframe class="embed-responsive-item" :src="this.url"></iframe>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import { APIService } from '../APIService'
const apiService = new APIService()
export default {
  name: 'RedirectServicos',
  props: [],
  components: { Loading },
  data() {
    return {
      idServico: this.$route.params.idServico,
      idSala: 0,
      objetoRetorno: {
        sucesso: false,
        aguarde: false,
        mensagem: null,
      },
      loader: false,
      intervalFetchStatus: null,
      url: null,
    }
  },
  computed: {
    toogleMicroApp() {
      return this.$store.state.toogleMicroApp
    },
  },
  created() {
    this.obterInfoRedirectServico()
  },
  methods: {
    obterInfoRedirectServico() {
      this.objetoRetorno.mensagem = null
      this.loader = true
      apiService
        .obterInfoRedirectServico(this.idServico, this.idSala)
        .then((response) => {
          this.objetoRetorno = response
          this.idSala = response.idSalaTriagem
          if (!this.objetoRetorno.aguarde && this.objetoRetorno.sucesso) {
            if (
              this.objetoRetorno.tipoServico == 'AGENDAMENTO_CONSULTA_MEDICA' ||
              this.objetoRetorno.tipoServico == 'AGENDAMENTO_EXAME'
            ) {
              this.url = this.objetoRetorno.url
            } else {
              window.location = this.objetoRetorno.url
            }
          } else {
            this.loader = false
            if (this.objetoRetorno.aguarde) {
              this.consultarStatus()
            }
          }
        })
    },
    consultarStatus() {
      this.intervalFetchStatus = setInterval(() => {
        this.loader = true
        apiService
          .obterInfoRedirectServico(this.idServico, this.idSala)
          .then((response) => {
            this.objetoRetorno = response
            this.idSala = response.idSalaTriagem
            if (!this.objetoRetorno.aguarde && this.objetoRetorno.sucesso) {
              this.loader = false
              clearInterval(this.intervalFetchStatus)
              window.location = this.objetoRetorno.url
            }
          })
      }, 20000)
    },
  },
  deactivated() {
    clearInterval(this.intervalFetchStatus)
  },
}
</script>
<style scoped lang="scss">
.alert {
  margin-right: 50px;
  margin-left: -50px;
}
</style>
